<template>
    <div>
        <UsageFIU :full="true" />
    </div>
</template>


<script setup>


    import AdminTable from '@/components/AdminTable.vue'
    import { ref, onMounted, computed } from 'vue';
    import { mapState } from 'vuex';
    import BO_API from '../api/bo_api.js'
    import UsageFIU from '@/views/UsageFIU.vue';
    

    onMounted(async () => {
        document.title = 'FIU Dashboard';
    })
</script>

<style scoped lang="scss">
    .main {
        width: 100vw;
        height: calc(100vh - 61px);
        display: flex;
        background: white;
    }
    .left-nav {
        padding: 20px;
        box-sizing: border-box;
        flex: 1;
        border-right: 1px solid gray;
    }
    .main-area {
        padding: 20px;
        box-sizing: border-box;
        flex: 5;
    }
    .date-selectors {
        display: flex;
        align-items: center;
        // justify-content: center;
        gap: 10px;
    }
</style>
